import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UploadModal from './UploadModal';
import CrawlModal from './CrawlModal';
import { SidebarActionsSection } from './sidebar/SidebarActionsSection';
import { SidebarConversationsSection } from './sidebar/SidebarConversationsSection';
import { SidebarFooter } from './sidebar/SidebarFooter';
import { SidebarKnowledgeBasesSection } from './sidebar/SidebarKnowledgeBasesSection';

function SidebarPanels({ knowledgeBases, selectedKB, onSelectKB, conversations, selectedConversation, onSelectConversation, onNewConversation, onOpenUploadModal, onOpenCrawlModal, onManageDocuments }) {
  return (
    <div className="flex h-full flex-col gap-6 overflow-y-auto bg-card/50 p-6 backdrop-blur-md">
      <SidebarKnowledgeBasesSection
        knowledgeBases={knowledgeBases}
        selectedKB={selectedKB}
        onSelectKB={onSelectKB}
      />

      {selectedKB ? (
        <SidebarActionsSection
          onUpload={onOpenUploadModal}
          onCrawl={onOpenCrawlModal}
          onManageDocuments={onManageDocuments}
        />
      ) : null}

      {selectedKB ? (
        <SidebarConversationsSection
          conversations={conversations}
          selectedConversation={selectedConversation}
          onSelectConversation={onSelectConversation}
          onNewConversation={onNewConversation}
        />
      ) : null}

      <SidebarFooter />
    </div>
  );
}

function SidebarModalLayer({ selectedKB, showUploadModal, showCrawlModal, onCloseUploadModal, onCloseCrawlModal, onRefreshKBs }) {
  if (!selectedKB) {
    return null;
  }

  return (
    <>
      {showUploadModal ? (
        <UploadModal
          knowledgeBaseId={selectedKB.id}
          onClose={onCloseUploadModal}
          onSuccess={() => {
            onCloseUploadModal();
            onRefreshKBs();
          }}
        />
      ) : null}

      {showCrawlModal ? (
        <CrawlModal
          knowledgeBaseId={selectedKB.id}
          onClose={onCloseCrawlModal}
          onSuccess={() => {
            onCloseCrawlModal();
            onRefreshKBs();
          }}
        />
      ) : null}
    </>
  );
}

export default function Sidebar({
  knowledgeBases,
  selectedKB,
  onSelectKB,
  conversations,
  selectedConversation,
  onSelectConversation,
  onNewConversation,
  onRefreshKBs,
}) {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showCrawlModal, setShowCrawlModal] = useState(false);
  const navigate = useNavigate();

  const openUploadModal = useCallback(() => setShowUploadModal(true), []);
  const openCrawlModal = useCallback(() => setShowCrawlModal(true), []);
  const closeUploadModal = useCallback(() => setShowUploadModal(false), []);
  const closeCrawlModal = useCallback(() => setShowCrawlModal(false), []);

  return (
    <>
      <SidebarPanels
        knowledgeBases={knowledgeBases}
        selectedKB={selectedKB}
        onSelectKB={onSelectKB}
        conversations={conversations}
        selectedConversation={selectedConversation}
        onSelectConversation={onSelectConversation}
        onNewConversation={onNewConversation}
        onOpenUploadModal={openUploadModal}
        onOpenCrawlModal={openCrawlModal}
        onManageDocuments={() => navigate('/documents')}
      />
      <SidebarModalLayer
        selectedKB={selectedKB}
        showUploadModal={showUploadModal}
        showCrawlModal={showCrawlModal}
        onCloseUploadModal={closeUploadModal}
        onCloseCrawlModal={closeCrawlModal}
        onRefreshKBs={onRefreshKBs}
      />
    </>
  );
}
